module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/tabs/spk-tab/spk-tab.component.scss
// module id = ./src/app/components/framework/spk/layouts/tabs/spk-tab/spk-tab.component.scss
// module chunks = main